import { render, staticRenderFns } from "./SOVnesplusDetailed.vue?vue&type=template&id=4c4be4da&scoped=true"
import script from "./SOVnesplusDetailed.vue?vue&type=script&lang=js"
export * from "./SOVnesplusDetailed.vue?vue&type=script&lang=js"
import style0 from "./SOVnesplusDetailed.vue?vue&type=style&index=0&id=4c4be4da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4be4da",
  null
  
)

export default component.exports